import { Card, Col, List, Row } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { StyleSheet } from "../StyleSheet";

export interface ListComponentData {
    title: string;
    subtitle: string
}

interface ItemNavigateOptionsProps {
    arrayList: Array<ListComponentData>;
    onPress: Function;
}

const ListComponent = (props: ItemNavigateOptionsProps) => {
    const { arrayList, onPress } = props;

    return (
        <List
            dataSource={arrayList}
            renderItem={(item) => (
                <Card onClick={() => onPress(item)} style={styles.viewRoot}>
                    <List.Item
                        actions={[<RightOutlined />]}
                    >
                        <Row gutter={[5, 5]}>
                            <Col style={styles.textTitle}>
                                {item.title}
                            </Col>
                            <Col style={styles.textSubtitle}>
                                {item.subtitle}
                            </Col>
                        </Row>
                    </List.Item>
                </Card>
            )}
        />
    );
};

const styles = StyleSheet.create({
    viewRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        cursor: "pointer",
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    textTitle: {
        marginLeft: 15,
        fontSize: "1.25em"
    },
    textSubtitle: {
        color: "#0055c2",
        fontSize: "1.25em",
        fontWeight: 600
    }
});

export default ListComponent;